import type { CustomFlagImage } from 'react-international-phone';

const customFlags: CustomFlagImage[] = [
  {
    iso2: 'ua',
    src: '/assets/icons/flags/Ukraine.svg',
  },
];

export { customFlags };
